// Who sees Ready for me (/work/ready) and the chip that leads there. Named by
// Patrick on 2026-10-01: himself, Eric and Walker. Same substring rule as
// auth/costAccess.js. This decides what is SHOWN; the analytics endpoint
// enforces the same list (READY_FOR_ME_VIEWERS) and returns 403 to anyone else.
export const READY_USER_SUBSTRINGS = ['patrick', 'eric', 'walker'];

export const isReadyUser = (profile) => {
    if (!profile) return false;
    const haystack = `${profile.name ?? ''} ${profile.email ?? ''} ${profile.preferred_username ?? ''}`.toLowerCase();
    return READY_USER_SUBSTRINGS.some((s) => haystack.includes(s));
};
